import React, { useState } from "react";
import styled from "styled-components";
import Header from "../components/Header";
import Layout from "../components/Layout";
import { FaLightbulb, FaHandsHelping, FaComments } from "react-icons/fa";

const RecruitmentContainer = styled.div``;

const Section = styled.section`
  padding: 5rem 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;

const SectionTitle = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 2rem;
  text-align: center;
  color: #333;
`;

const Message = styled.div`
  text-align: center;
  margin-bottom: 4rem;
  /* 背面を通るTRロゴと重なっても読めるよう半透明白のパネルに */
  background: rgba(255, 255, 255, 0.86);
  backdrop-filter: blur(3px);
  border-radius: 8px;
  padding: 1.5rem 2rem;

  p {
    font-size: 1.2rem;
    line-height: 1.8;
    color: #666;
    max-width: 800px;
    margin: 0 auto;
  }
`;

const JobGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
`;

const JobCard = styled.div`
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
  display: flex;
  flex-direction: column;
  height: 100%;

  &:hover {
    transform: translateY(-10px);
  }
`;

const JobHeader = styled.div`
  background-color: #0090a0;
  color: #fff;
  padding: 1.5rem;

  h3 {
    font-size: 1.5rem;
    margin-bottom: 0.5rem;
  }

  p {
    font-size: 1rem;
    opacity: 0.9;
  }
`;

const JobContent = styled.div`
  padding: 1.5rem;
  flex: 1; /* 利用可能なスペースを埋める */

  h4 {
    font-size: 1.2rem;
    margin-bottom: 1rem;
    color: #333;
    border-bottom: 1px solid #eee;
    padding-bottom: 0.5rem;
  }

  ul {
    list-style: disc;
    margin-left: 1.5rem;
    margin-bottom: 1.5rem;
    color: #666;
    line-height: 1.6;
  }
`;

const ApplyButton = styled.button`
  display: block;
  width: 100%;
  padding: 1rem;
  background-color: #0090a0;
  color: #fff;
  text-align: center;
  font-weight: 500;
  font-size: 1rem;
  transition: background-color 0.3s ease;
  cursor: pointer;
  border: none;

  &:hover {
    background-color: #007580;
  }
`;

const CultureSection = styled.div`
  margin-top: 6rem;
`;

const CultureGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
`;

const CultureItem = styled.div`
  text-align: center;
  /* 背面を通るTRロゴと重なっても読めるよう半透明白のパネルに */
  background: rgba(255, 255, 255, 0.86);
  backdrop-filter: blur(3px);
  border-radius: 8px;
  padding: 2rem 1.5rem;

  .icon {
    font-size: 3rem;
    color: #0090a0;
    margin-bottom: 1rem;
  }

  h3 {
    font-size: 1.5rem;
    margin-bottom: 1rem;
    color: #333;
  }

  p {
    color: #666;
    line-height: 1.6;
  }
`;

const BenefitsSection = styled.div`
  margin-top: 6rem;
`;

const BenefitsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
`;

const BenefitItem = styled.div`
  background-color: #fff;
  border-radius: 8px;
  padding: 2rem;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;

  &:hover {
    transform: translateY(-5px);
  }

  .icon {
    font-size: 2.5rem;
    color: #0090a0;
    margin-bottom: 1rem;
  }

  h3 {
    font-size: 1.3rem;
    margin-bottom: 1rem;
    color: #333;
    border-bottom: 1px solid #eee;
    padding-bottom: 0.5rem;
  }

  p {
    color: #666;
    line-height: 1.6;
  }
`;

const ThankYouModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background-color: #fff;
  padding: 2rem;
  border-radius: 8px;
  max-width: 500px;
  width: 90%;
  text-align: center;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);

  h3 {
    font-size: 1.8rem;
    color: #0090a0;
    margin-bottom: 1rem;
  }

  p {
    font-size: 1.2rem;
    color: #666;
    line-height: 1.6;
    margin-bottom: 1.5rem;
  }

  button {
    padding: 0.8rem 1.5rem;
    background-color: #0090a0;
    color: #fff;
    border: none;
    border-radius: 4px;
    font-size: 1rem;
    cursor: pointer;
    transition: background-color 0.3s ease;

    &:hover {
      background-color: #007580;
    }
  }
`;

const Recruitment = () => {
  const [showThankYou, setShowThankYou] = useState(false);
  return (
    <Layout>
      <RecruitmentContainer>
        <Header
          title="採用情報"
          subtitle="共に未来を創る仲間を募集しています"
          showButton={false}
        />

        <Section>
          <SectionTitle data-aos="fade-down">募集職種</SectionTitle>
          <Message data-aos="fade-up">
            <p>
              テクノロイグでは、技術力だけでなく、チームワークを大切にし、
              常に新しいことに挑戦する意欲を持った方を募集しています。
              私たちと一緒に、テクノロジーの力で社会に貢献しませんか？
            </p>
          </Message>

          <JobGrid>
            <JobCard data-aos="fade-up" data-aos-delay="0">
              <JobHeader>
                <h3>フロントエンドエンジニア</h3>
                <p>正社員 年収400万円~</p>
              </JobHeader>
              <JobContent>
                <h4>業務内容</h4>
                <ul>
                  <li>Webフロントエンド開発</li>
                  <li>UI/UX実装</li>
                  <li>レスポンシブデザイン実装</li>
                  <li>パフォーマンス最適化</li>
                </ul>

                <h4>求めるスキル・経験</h4>
                <ul>
                  <li>React, Vue, Svelteなどのフレームワーク経験</li>
                  <li>SCSSの実装経験</li>
                </ul>
              </JobContent>
              <ApplyButton
                onClick={() => handleApply("フロントエンドエンジニア")}
              >
                応募する
              </ApplyButton>
            </JobCard>

            <JobCard data-aos="fade-up" data-aos-delay="100">
              <JobHeader>
                <h3>バックエンドエンジニア</h3>
                <p>正社員 年収400万円~</p>
              </JobHeader>
              <JobContent>
                <h4>業務内容</h4>
                <ul>
                  <li>サーバーサイド開発</li>
                  <li>データベース設計・実装</li>
                  <li>APIの設計・開発</li>
                  <li>セキュリティ対策</li>
                </ul>

                <h4>求めるスキル・経験</h4>
                <ul>
                  <li>
                    Node.js, Ruby, Python, PHPなどのサーバーサイド開発経験
                  </li>
                  <li>SQLを用いたデータベースの知識</li>
                  <li>RESTful API設計の経験</li>
                </ul>
              </JobContent>
              <ApplyButton
                onClick={() => handleApply("バックエンドエンジニア")}
              >
                応募する
              </ApplyButton>
            </JobCard>

            <JobCard data-aos="fade-up" data-aos-delay="200">
              <JobHeader>
                <h3>フルスタックエンジニア</h3>
                <p>正社員 年収400万円~</p>
              </JobHeader>
              <JobContent>
                <h4>業務内容</h4>
                <ul>
                  <li>フロントエンド・バックエンド両方の開発</li>
                  <li>アーキテクチャ設計</li>
                  <li>クライアントとの要件定義</li>
                  <li>設計・テスト・運用保守</li>
                </ul>

                <h4>求めるスキル・経験</h4>
                <ul>
                  <li>フロントエンド・バックエンド両方の開発経験</li>
                  <li>システム設計の経験</li>
                </ul>
              </JobContent>
              <ApplyButton
                onClick={() => handleApply("フルスタックエンジニア")}
              >
                応募する
              </ApplyButton>
            </JobCard>

            <JobCard data-aos="fade-up" data-aos-delay="300">
              <JobHeader>
                <h3>モバイルアプリエンジニア</h3>
                <p>正社員 年収400万円~</p>
              </JobHeader>
              <JobContent>
                <h4>業務内容</h4>
                <ul>
                  <li>iOSおよびAndroidアプリ開発</li>
                  <li>クロスプラットフォーム開発</li>
                  <li>アプリのパフォーマンス最適化</li>
                </ul>

                <h4>求めるスキル・経験</h4>
                <ul>
                  <li>Swift/Kotlin/Java等でのネイティブアプリ開発経験</li>
                  <li>アプリのリリース・運用経験</li>
                </ul>
              </JobContent>
              <ApplyButton
                onClick={() => handleApply("モバイルアプリエンジニア")}
              >
                応募する
              </ApplyButton>
            </JobCard>

            <JobCard data-aos="fade-up" data-aos-delay="400">
              <JobHeader>
                <h3>インフラエンジニア</h3>
                <p>正社員 年収400万円~</p>
              </JobHeader>
              <JobContent>
                <h4>業務内容</h4>
                <ul>
                  <li>クラウドインフラ設計・構築</li>
                  <li>サーバー・ネットワーク管理</li>
                  <li>セキュリティ対策</li>
                  <li>CI/CD環境の構築・運用</li>
                </ul>

                <h4>求めるスキル・経験</h4>
                <ul>
                  <li>AWS, GCP, Azureなどのクラウドサービス経験</li>
                  <li>Docker, Kubernetesなどのコンテナ技術</li>
                </ul>
              </JobContent>
              <ApplyButton onClick={() => handleApply("インフラエンジニア")}>
                応募する
              </ApplyButton>
            </JobCard>

            <JobCard data-aos="fade-up" data-aos-delay="500">
              <JobHeader>
                <h3>プロジェクトマネージャー</h3>
                <p>正社員 年収450万円~</p>
              </JobHeader>
              <JobContent>
                <h4>業務内容</h4>
                <ul>
                  <li>プロジェクト全体の管理・進行</li>
                  <li>クライアントとのコミュニケーション</li>
                  <li>チームマネジメント</li>
                  <li>スケジュール・予算管理</li>
                </ul>

                <h4>求めるスキル・経験</h4>
                <ul>
                  <li>IT/ソフトウェア開発プロジェクトの管理経験</li>
                  <li>アジャイル/スクラム開発手法の理解</li>
                  <li>コミュニケーション能力</li>
                  <li>リスク管理・問題解決能力</li>
                </ul>
              </JobContent>
              <ApplyButton
                onClick={() => handleApply("プロジェクトマネージャー")}
              >
                応募する
              </ApplyButton>
            </JobCard>
          </JobGrid>
        </Section>

        {showThankYou && (
          <ThankYouModal>
            <ModalContent>
              <h3>応募ありがとうございます</h3>
              <p>
                メールが自動的に開かない場合はお手数ですが直接
                info@technoroaig.com までご連絡ください。
              </p>
              <button onClick={() => setShowThankYou(false)}>閉じる</button>
            </ModalContent>
          </ThankYouModal>
        )}

        <Section>
          <CultureSection>
            <SectionTitle data-aos="fade-down">企業文化</SectionTitle>
            <Message data-aos="fade-up">
              <p>
                テクノロイグでは、以下の3つの企業バリューを大切にしています。
                これらの価値観を共有できる仲間と共に、より良い未来を創造していきたいと考えています。
              </p>
            </Message>
            <CultureGrid>
              <CultureItem data-aos="fade-right" data-aos-delay="0">
                <div className="icon">
                  <FaLightbulb />
                </div>
                <h3>未来志向で学び続けよう</h3>
                <p>
                  私たちは常に前を向き、新しい技術やアイデアを学び続けることを大切にしています。
                  変化の激しいIT業界において、学習を止めないことが成長と革新の鍵です。
                  好奇心を持ち、挑戦し続けることで、未来を創造していきます。
                </p>
              </CultureItem>

              <CultureItem data-aos="fade-right" data-aos-delay="200">
                <div className="icon">
                  <FaHandsHelping />
                </div>
                <h3>Giverマインドであろう</h3>
                <p>
                  私たちは「与える文化」を大切にしています。知識、努力、サポートを惜しみなく提供し、
                  チームメンバーや顧客、社会に価値を届けることを心がけています。
                  与えることで信頼関係を築き、共に成長する環境を創り出します。
                </p>
              </CultureItem>

              <CultureItem data-aos="fade-right" data-aos-delay="400">
                <div className="icon">
                  <FaComments />
                </div>
                <h3>対話を大切にしよう</h3>
                <p>
                  私たちは会社のモメンタムを大切にしており、対話をとても重視しています。
                  Slackのtimesチャンネルや定例ミーティング、イベントなどを通して、それぞれの想い、意見、楽しかったことの共有等を通して互いをよく理解し、より良い未来を共に創造していきます。
                </p>
              </CultureItem>
            </CultureGrid>
          </CultureSection>
        </Section>

        <Section>
          <BenefitsSection>
            <SectionTitle data-aos="fade-down">福利厚生</SectionTitle>
            <Message data-aos="fade-up">
              <p>
                テクノロイグでは、社員の皆さんが安心して働き、プライベートも充実させられるよう、
                様々な福利厚生制度を用意しています。一人ひとりのライフスタイルに合わせた働き方をサポートします。
              </p>
            </Message>
            <BenefitsGrid>
              <BenefitItem data-aos="zoom-in" data-aos-delay="0">
                <div className="icon">📚</div>
                <h3>書籍購入補助</h3>
                <p>
                  スキルを身につけるための必要な書籍があれば会社で購入します。学び続けることは弊社の大切にしているバリューの一つです。
                </p>
              </BenefitItem>

              <BenefitItem data-aos="zoom-in" data-aos-delay="100">
                <div className="icon">🤖</div>
                <h3>ChatGPT Plus プランを全社員に付与</h3>
                <p>
                  最新のAIを普段から触れることは将来のITエンジニアの在り方を考える際に不可欠です。ChatGPT
                  Plusプランを全社員に付与だけでなくCursorやGithub
                  Copilot等、興味のあるAIプロダクトへの課金を適宜相談しながらAIに触れ学び続けることを大切にしています。
                </p>
              </BenefitItem>

              <BenefitItem data-aos="zoom-in" data-aos-delay="200">
                <div className="icon">💼</div>
                <h3>副業推進</h3>
                <p>
                  副業での経験は必ずエンジニアの未来にプラスになるものだと考え、本業の業務時間に影響がない副業は推進しています。
                </p>
              </BenefitItem>

              <BenefitItem data-aos="zoom-in" data-aos-delay="300">
                <div className="icon">📅</div>
                <h3>入社後すぐに有給休暇を付与</h3>
                <p>
                  入社日すぐの不測の事態や、個人都合での休暇に対応できるよう入社後すぐ10日の有給休暇を付与しています。
                </p>
              </BenefitItem>

              <BenefitItem data-aos="zoom-in" data-aos-delay="400">
                <div className="icon">🎉</div>
                <h3>交流イベントがたくさん</h3>
                <p>
                  「ポジティブに会社に所属してほしい」という思いから、キャンプや屋形船、旅行などイベントをたくさん開催しています。
                </p>
              </BenefitItem>

              <BenefitItem data-aos="zoom-in" data-aos-delay="500">
                <div className="icon">🤝</div>
                <h3>リファラル採用成果手当</h3>
                <p>
                  リファラル採用が成功した場合、採用者を紹介いただいた従業員には成果手当として50万円を支給しています。
                </p>
              </BenefitItem>

              <BenefitItem data-aos="zoom-in" data-aos-delay="600">
                <div className="icon">✨</div>
                <h3>その他</h3>
                <ul
                  style={{
                    listStyle: "disc",
                    marginLeft: "1.5rem",
                    color: "#666",
                    lineHeight: "1.6",
                  }}
                >
                  <li>各種社会保険完備</li>
                  <li>賞与（6月、12月）</li>
                  <li>見込み残業制度なし</li>
                  <li>完全週休二日制(土曜日、日曜日)</li>
                  <li>夏季特別休暇5日</li>
                  <li>年末年始特別休暇(12月29日~1月3日)</li>
                </ul>
                <span
                  style={{
                    listStyle: "disc",
                    color: "#666",
                    lineHeight: "1.6",
                  }}
                >
                  などなど
                </span>
              </BenefitItem>
            </BenefitsGrid>
          </BenefitsSection>
        </Section>
      </RecruitmentContainer>
    </Layout>
  );

  // 応募ボタンがクリックされたときの処理
  function handleApply(position) {
    // メール送信用のデータを準備
    const mailtoLink = `mailto:info@technoroaig.com?subject=${encodeURIComponent(
      `【採用応募】${position}`,
    )}&body=${encodeURIComponent(
      `職種: ${position}\n\n` +
        `以下の情報をご記入ください：\n` +
        `お名前: \n` +
        `メールアドレス: \n` +
        `電話番号: \n` +
        `簡単な経歴・スキル: \n\n` +
        `その他メッセージ: \n`,
    )}`;

    // メーラーを開く
    window.open(mailtoLink, "_blank");

    // サンクスモーダルを表示
    setShowThankYou(true);
  }
};

export default Recruitment;
